import { EventCatalogFromKeys, EventType } from "../../types";

export const AdminTaxReceiptsEventKeys = {
  ADMIN_TAX_EXEMPT_SETTINGS_UPDATE: "admin-tax-exempt-settings-update",
  ADMIN_TAX_RECEIPT_AUTO_CREATE_FAILURE:
    "admin-tax-receipt-auto-create-failure",
  ADMIN_TAX_RECEIPT_DOWNLOAD_FAILURE: "admin-tax-receipt-download-failure",
  ADMIN_TAX_RECEIPT_EMAIL_FAILURE: "admin-tax-receipt-email-failure",
  ADMIN_TAX_RECEIPT_FORM_SUBMIT_ATTEMPT:
    "admin-tax-receipt-form-submit-attempt",
  ADMIN_TAX_RECEIPT_FORM_SUBMIT_FAILURE:
    "admin-tax-receipt-form-submit-failure",
  ADMIN_TAX_RECEIPT_FORM_SUBMIT_SUCCESS:
    "admin-tax-receipt-form-submit-success",
  ADMIN_TAX_RECEIPT_SKIPPED_NO_ADDRESS: "admin-tax-receipt-skipped-no-address",
  ADMIN_TAX_RECEIPT_TABLE_FILTER_DONOR: "admin-tax-receipt-filter-donor",
  ADMIN_TAX_RECEIPT_TABLE_FILTER_NEED: "admin-tax-receipt-filter-need",
  ADMIN_TAX_RECEIPT_TABLE_FILTER_RECEIPT_NUMBER:
    "admin-tax-receipt-filter-receipt-number",
  ADMIN_TAX_RECEIPT_TABLE_FILTER_STATUS: "admin-tax-receipt-filter-status",
  ADMIN_TAX_RECEIPT_TABLE_FILTER_VALUE: "admin-tax-receipt-filter-value",
  ADMIN_TAX_RECEIPT_TABLE_SEARCH: "admin-tax-receipt-search",
  ADMIN_TAX_RECEIPTS_DISABLE: "admin-tax-receipts-disable",
  ADMIN_TAX_RECEIPTS_ENABLE: "admin-tax-receipts-enable",
  ADMIN_TAX_RECEIPTS_PAGE_VIEW: "admin-tax-receipts-page-view",
} as const;

export const AdminTaxReceiptsEventCatalog: EventCatalogFromKeys<
  typeof AdminTaxReceiptsEventKeys
> = {
  [AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPTS_PAGE_VIEW]: {
    description: "Admin viewed the tax receipts page",
    eventType: EventType.PAGE_VIEW,
    id: AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPTS_PAGE_VIEW,
  },
  [AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_FORM_SUBMIT_ATTEMPT]: {
    description: "Admin attempted to submit the tax receipt form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_FORM_SUBMIT_ATTEMPT,
  },
  [AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_FORM_SUBMIT_FAILURE]: {
    description: "Admin failed to submit the tax receipt form",
    eventType: EventType.ERROR,
    id: AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_FORM_SUBMIT_FAILURE,
  },
  [AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_FORM_SUBMIT_SUCCESS]: {
    description: "Admin successfully submitted the tax receipt form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_FORM_SUBMIT_SUCCESS,
  },
  [AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_TABLE_FILTER_DONOR]: {
    description: "Admin filtered tax receipts by donor",
    eventType: EventType.TABLE_FILTER,
    id: AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_TABLE_FILTER_DONOR,
  },
  [AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_TABLE_FILTER_NEED]: {
    description: "Admin filtered tax receipts by need",
    eventType: EventType.TABLE_FILTER,
    id: AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_TABLE_FILTER_NEED,
  },
  [AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_TABLE_FILTER_RECEIPT_NUMBER]: {
    description: "Admin filtered tax receipts by receipt number",
    eventType: EventType.TABLE_FILTER,
    id: AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_TABLE_FILTER_RECEIPT_NUMBER,
  },
  [AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_TABLE_FILTER_STATUS]: {
    description: "Admin filtered tax receipts by status",
    eventType: EventType.TABLE_FILTER,
    id: AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_TABLE_FILTER_STATUS,
  },
  [AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_TABLE_FILTER_VALUE]: {
    description: "Admin filtered tax receipts by value",
    eventType: EventType.TABLE_FILTER,
    id: AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_TABLE_FILTER_VALUE,
  },
  [AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_TABLE_SEARCH]: {
    description: "Admin searched for a tax receipt",
    eventType: EventType.FILTER,
    id: AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_TABLE_SEARCH,
  },
  [AdminTaxReceiptsEventKeys.ADMIN_TAX_EXEMPT_SETTINGS_UPDATE]: {
    description: "Admin updated tax-exempt settings",
    eventType: EventType.INTERACTION,
    id: AdminTaxReceiptsEventKeys.ADMIN_TAX_EXEMPT_SETTINGS_UPDATE,
  },
  [AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPTS_ENABLE]: {
    description: "Admin enabled tax receipts feature",
    eventType: EventType.INTERACTION,
    id: AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPTS_ENABLE,
  },
  [AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPTS_DISABLE]: {
    description: "Admin disabled tax receipts feature",
    eventType: EventType.INTERACTION,
    id: AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPTS_DISABLE,
  },
  [AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_AUTO_CREATE_FAILURE]: {
    description: "Auto-creation of a tax receipt on claim completion failed",
    eventType: EventType.ERROR,
    id: AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_AUTO_CREATE_FAILURE,
  },
  [AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_SKIPPED_NO_ADDRESS]: {
    description: "Tax receipt skipped because the donor has no mailing address",
    eventType: EventType.INTERACTION,
    id: AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_SKIPPED_NO_ADDRESS,
  },
  [AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_DOWNLOAD_FAILURE]: {
    description: "Admin failed to download a tax receipt",
    eventType: EventType.ERROR,
    id: AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_DOWNLOAD_FAILURE,
  },
  [AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_EMAIL_FAILURE]: {
    description: "Admin failed to email a tax receipt",
    eventType: EventType.ERROR,
    id: AdminTaxReceiptsEventKeys.ADMIN_TAX_RECEIPT_EMAIL_FAILURE,
  },
};
